import React from "react";
import Card from "./CardStucher";
import FormRenderer from "Common/Custom/FormRenderer";

const ParkingBookingSection = ({
  values,
  errors,
  handleChange,
  parkingFields,
}) => {
  const handleParkingChange = (e) => {
    handleChange(e);

    if (e.target.name === "is_parking" && e.target.value === "0") {
      handleChange({
        target: {
          name: "total_vehicle",
          value: 0,
        },
      });
    }
  };

  const fields = parkingFields.map((field) =>
    field.name === "total_vehicle"
      ? {
          ...field,
          disabled: values.is_parking !== "1",
        }
      : field
  );

  return (
    <Card
      heading={<h6 className="card-title">Parking Booking</h6>}
      CardHeaderClass="card-header"
      CardRowClass="row g-3"
      isRow={false}
      

    >
      <FormRenderer
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleParkingChange}
      />
    </Card>
  );
};

export default ParkingBookingSection;

